import DashboardTemplate from './DashboardTemplate';
import { Shield } from 'lucide-react';

const MGADashboard = () => {
  return (
    <DashboardTemplate
      functionType="mga"
      title="MGA"
      subtitle="Gross Written Premium, Loss Ratio, Combined Ratio & Capacity"
      icon={Shield}
    />
  );
};

export default MGADashboard;
